import React from 'react'
import styles from './styles.module.scss'
import MixAndMatch from './MixAndMatch'
import ShopCollection from './ShopCollection'
import FitProposition from './FitProposition'
import ProductsBreakdown from './ProductsBreakdown'
import AssetCallOut from './AssetCallOut'
import Hero from './Hero'

const EndurosRange = () => {
  return (
    <>
      <Hero />
      <div className={styles.productsBreakdownSection}>
        <ProductsBreakdown />
      </div>
      <div className={styles.callOutSection}>
        <AssetCallOut />
      </div>
      <div className={styles.mixAndMatchSection}>
        <MixAndMatch />
      </div>
      <FitProposition />
      <div className={styles.content__text}>
        <ShopCollection />
      </div>
    </>
  )
}

export default EndurosRange
